<div class="consultorio-historico-container">
    <app-custom-table [data]="registros()" [metadata]="tableMetadata" [loading]="loading()"></app-custom-table>
    @if (!loading() && erro()) {
        <div class="mt-2 text-red-500">{{ erro() }}</div>
    }
</div>
